import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { enumSocialMediaPostType } from "../../../../enums";
import { ISocialMediaPostDisplaySpecs } from "../ISocialMediaPostDisplaySpecs";

/**
 * @function deriveDisplaySpecsForFacebookPost Derives the specs needed to display a Facebook Social Media Post from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function deriveDisplaySpecsForFacebookPost(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // set default displaySpecs values for FacebookPost
  let displaySpecs: ISocialMediaPostDisplaySpecs = { socialMediaPostType: enumSocialMediaPostType.Undefined, url: '', width: '100%', height: '100%' };;

  // execute the regular expression against the url to determine if the socialMediaPostRawReference represents a standard Facebook Post EmbedUrl
  const matchEmbedUrl: RegExpExecArray | null = RegularExpressions.FacebookPostEmbedUrl.exec(socialMediaPostRawReference);

  // if a match was made for a simple embed url...
  if (matchEmbedUrl && matchEmbedUrl.groups && matchEmbedUrl.groups.embedUrl) {
    // set the specs for displaying the post
    displaySpecs = { socialMediaPostType: enumSocialMediaPostType.FacebookPost, url: matchEmbedUrl.groups.embedUrl, width: '100%', height: '100%' };
  } else {
    // In this fragment, determine if the reference is an IFrame. Since a Facebook Post IFrame reference has an encoded URI (for the 'href'), we need to first decode
    // the referenece before using a Regular Expression to see if the reference matches a Facebook Post IFrame reference.
    const socialMediaPostRawReferenceDecoded: string = decodeURIComponent(socialMediaPostRawReference);

    // execute the regular expression against the decoded socialMediaPostRawReference to determine if the socialMediaPostRawReference represents a Facebook Post IFrame with full specs
    const matchIFrameWithFullSpecs: RegExpExecArray | null = RegularExpressions.FacebookPostIFrameWithFullSpecs.exec(socialMediaPostRawReferenceDecoded);

    // if a match was made for an <iframe>...
    if (matchIFrameWithFullSpecs && matchIFrameWithFullSpecs.groups) {
      // set the Social Media Post Type
      displaySpecs.socialMediaPostType = enumSocialMediaPostType.FacebookPost;

      // if the embedUrl is found...
      if (matchIFrameWithFullSpecs.groups.embedUrl) {
        displaySpecs.url = matchIFrameWithFullSpecs.groups.embedUrl;
      }

      // if the 'height' parameter was found, ... 
      if (matchIFrameWithFullSpecs.groups.height) {
        // convert to a number and set value into the displaySpecs.height variable
        displaySpecs.height = parseInt(matchIFrameWithFullSpecs.groups.height);
      }

      // if the 'width' parameter was found, ... 
      if (matchIFrameWithFullSpecs.groups.width) {
        // convert to a number and set value into the displaySpecs.width variable
        displaySpecs.width = parseInt(matchIFrameWithFullSpecs.groups.width);
      }
    }
  }

  return displaySpecs;
}
